export default __webpack_public_path__ + "f6ecb617da2399a5f2e0bd84c3177852.png";